module.exports = __webpack_public_path__ + "0672ddb3e22378594ba3486620525c14.eot";